<template>
    <div class="selectInput">
        <div class="el-select">
            <div class="el-input el-input--suffix">
            <input type="text" autocomplete="off" class="el-input__inner" placeholder="请选择" v-model="selectCon" @click.stop="liShow"/>
            <!-- <i class="el-icon-caret-bottom" @click.stop="liShow"></i> -->
            <span class="el-input__suffix">
                <span class="el-input__suffix-inner">
                    <i class="el-select__caret el-input__icon el-icon-caret-top" >
                    </i>
                </span>
            </span>
        </div>
        </div>
        <!-- 下拉列表 -->
        <ul v-show="isShow" @click.stop="liShow">
            <li v-for="item in liData" :key="item.Id">
                <!-- <label :id="item.Id"> -->
                    <el-checkbox v-model="item.check">{{item.name}}</el-checkbox>
                    <!-- <input type="checkbox" v-model="item.check" />
                    {{item.name}} -->
                <!-- </label> -->
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name:"selectInput",
    data(){
        return {
            checkedData:[],// 选中的数据
            isShow:false, // 下拉列表是否显示
            selectCon:"", //选中的内容
            active:false,
        }
    },
    props:["liData"],
    mounted(){
        let that = this;
        // 点击页面空白处隐藏下拉列表
        document.addEventListener("click", function(){
            that.isShow = false;
            this.active = true
        });
    },
    methods:{
        // 控制下拉列表的显示隐藏
        liShow(){
            this.isShow = true;
        }
    },
    watch:{
        liData:{
            handler(newVal, oldVal){
                // 选中数据
                this.checkedData = newVal.filter(function(item){
                    return item.check == true;
                });
                // 在页面打印出的数据
                this.selectCon = ""; // 点击的当前项的展示
                for(let i = 0; i < this.checkedData.length; i++){
                    this.selectCon += this.checkedData[i].name + " ";
                }
                // 给父组件传值
                this.$emit("change", this.selectCon);
            },
            deep: true
        }
    }
}
</script>
<style scoped>
/* .selectInput .title {
    width: 300px;
    position: relative;
} */
/* .selectInput input[type="text"]{
    width: 300px;
    height: 35px;
    padding: 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 3px;
} */
/* .selectInput i {
    position: absolute;
    widows: 30px;
    height: 35px;
    line-height: 35px;
    right: -12px;
    top: 1px;
    text-align: center;
    cursor: pointer;
} */
.selectInput{
    width: 100%;
}
.selectInput ul {
    border-radius: 3px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    /* width: 253px;
    padding: 10px 30px; */
    padding: 0;
    width: 100%;
    margin-top: 5px;
}
.selectInput li {
    line-height: 30px;
    margin: 0;
    padding: 0;
    list-style: none;
    text-align: left;
    font-size: 15px;
    padding-left: 10px;
    box-sizing: border-box;
}
.selectInput .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    widows: 100%;
}
.selectInput .el-input__inner{
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    box-sizing: border-box;
    display: inline-block;
    font-size: inherit;
    line-height: 40px;
    outline: 0;
    height: 35px;
    padding: 0 10px;
    border: 1px solid #409eff;
    color: #000;
}
.el-input__suffix{
    right: 5px;
    transition: all .3s;
}
.el-input__prefix, 
.el-input__suffix{
    position: absolute;
    top: 0;
    height: 100%;
    color: #c0c4cc;
    text-align: center;
}
.el-input__suffix, .el-tree.is-dragging .el-tree-node__content *{
    pointer-events: none;
}
.el-input__suffix-inner{
    pointer-events: all;
}
.el-select .el-input .el-select__caret{
    color: #c0c4cc;
    font-size: 14px;
    transform: rotateZ(180deg);
    cursor: pointer;
}
.el-input__icon{
    height: 100%;
    width: 25px;
    text-align: center;
    line-height: 40px;
}
/* [class*=" el-icon-"], [class^=el-icon-]{
    font-family:element-icons!important;
    speak:none;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    text-transform: none;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing:antialiased;
} */
.el-icon-arrow-up:before{
    content:"\E6E1"
}
.el-input__icon:after{
    content: "";
    height: 100%;
    width: 0;
    display: inline-block;
    vertical-align: middle;
}
.el-select .el-input .el-select__caret.is-reverse{
    transform: rotateZ(0);
}
.selectInput >>> li .el-checkbox__inner{
    width: 14px !important;
    height: 14px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/selectInput.vue